import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { Download, BookOpen } from 'lucide-react';
export function ResourcesSection() {
  return <Section background="white" className="text-center" data-id="element-165">
      <div className="max-w-4xl mx-auto bg-brand-primary/5 rounded-3xl p-8 md:p-16 border border-brand-primary/10" data-id="element-166">
        <div className="mb-8" data-id="element-167">
          <span className="inline-block px-4 py-1.5 mb-4 text-xs font-bold tracking-wider text-brand-primary uppercase bg-white rounded-full border border-brand-primary/20" data-id="element-168">
            Resurse Gratuite
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-brand-text mb-4" data-id="element-169">
            Cadoul meu pentru tine
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto mb-8" data-id="element-170">
            Primești acces la materiale practice (exerciții simple, ghidaje,
            invitații la training-uri live), ca să începi să lucrezi cu tine
            chiar de acum.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-171">
          <Button variant="primary" className="flex items-center justify-center" data-id="element-172">
            <Download className="mr-2 w-5 h-5" data-id="element-173" />
            Primește Resursele Gratuite
          </Button>
          <Button variant="outline" className="flex items-center justify-center" data-id="element-174">
            <BookOpen className="mr-2 w-5 h-5" data-id="element-175" />
            Citește Articole Blog
          </Button>
        </div>
      </div>
    </Section>;
}